export default __webpack_public_path__ + "static/media/6c.27b99a47.png";